import config from '../../../config';

export class SponsorshipSetService {
  constructor(fetchService) {
    this.fetchService = fetchService;
  }

  activateSponsorshipSet = async ({ campaignId, sponsorshipSetId }) => {
    const res = await this.fetchService.fetch({
      url: `${config.campaignsAPI}/watchandrespond/${campaignId}/sponsorshipset/${sponsorshipSetId}/activate`,
      method: 'POST',
      newVersionApi: '2.0',
    });

    if (res.status !== 200 && res.status !== 201) {
      const error = new Error('Unable to get acceptance over time chart.');
      error.statusCode = res.status || 500;
      throw error;
    }

    return res.data;
  };

  deactivateSponsorshipSet = async ({ campaignId, sponsorshipSetId }) => {
    const res = await this.fetchService.fetch({
      url: `${config.campaignsAPI}/watchandrespond/${campaignId}/sponsorshipset/${sponsorshipSetId}/deactivate`,
      method: 'POST',
      newVersionApi: '2.0',
    });

    if (res.status !== 200 && res.status !== 201) {
      const error = new Error('Unable to get acceptance over time chart.');
      error.statusCode = res.status || 500;
      throw error;
    }

    return res.data;
  };

  updateSponsorshipSet = async ({
    campaignId,
    sponsorshipSetId,
    name,
    ageRanges,
    genders,
    isEightPixelEnabled,
    pixelConversionEvent,
    includeLocations,
    excludeLocations,
    interests,
    passions,
    eightPixelAudiences,
    includeTags,
    excludeTags,
    scheduleFrom,
    scheduleTo,
    charityInfo,
    timezoneId,
    timezoneInfo,
    charityDonation,
    netCashReward,
    weAre8Fee,
    pricePerMessage,
    budgetTotal,
    samiPricingId,
    deviceType,
  }) => {
    const additionalOtions = isEightPixelEnabled && { pixelConversionEvent };

    const response = await this.fetchService.fetch({
      url: `${config.campaignsAPI}/watchandrespond/${campaignId}/sponsorshipset/`,
      method: 'POST',
      bodyType: 'json',
      body: {
        sponsorshipSetId,
        name,
        ageRanges,
        genders,
        isEightPixelEnabled,
        includeLocations,
        excludeLocations,
        interests,
        passions,
        eightPixelAudiences,
        includeTags,
        excludeTags,
        scheduleFrom,
        scheduleTo,
        timezoneId,
        timezoneInfo,
        charityInfo,
        charityDonation,
        netCashReward,
        weAre8Fee,
        pricePerMessage,
        budgetTotal,
        samiPricingId,
        deviceType,
        ...additionalOtions,
      },
      newVersionApi: '4.3',
    });

    if (response.status !== 200 && response.status !== 201) {
      const error = new Error('Unable to get acceptance over time chart.');
      error.statusCode = response.status || 500;
      throw error;
    }

    return response.data;
  };
}
